import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
var useCharLimit = function useCharLimit(_ref) {
  var _ref$hideOnBlur = _ref.hideOnBlur,
    hideOnBlur = _ref$hideOnBlur === void 0 ? true : _ref$hideOnBlur,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue,
    _ref$tooltipAlignment = _ref.tooltipAlignment,
    tooltipAlignment = _ref$tooltipAlignment === void 0 ? 'BOTTOM' : _ref$tooltipAlignment;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isValid = _React$useState2[0],
    setValid = _React$useState2[1];
  var _React$useState3 = React.useState(initialValue),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    value = _React$useState4[0],
    setValue = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    show = _React$useState6[0],
    setShow = _React$useState6[1];
  var onValidation = function onValidation(v) {
    setValid(v);
  };
  return {
    showCharLimit: show,
    getTextInputProps: function getTextInputProps(_ref2) {
      var _ref2$onChange = _ref2.onChange,
        _onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
        _ref2$onFocus = _ref2.onFocus,
        _onFocus = _ref2$onFocus === void 0 ? function () {} : _ref2$onFocus,
        _ref2$onBlur = _ref2.onBlur,
        _onBlur = _ref2$onBlur === void 0 ? function () {} : _ref2$onBlur,
        _ref2$invalidMessage = _ref2.invalidMessage,
        invalidMessage = _ref2$invalidMessage === void 0 ? 'Text is too long' : _ref2$invalidMessage;
      return {
        value: value,
        isValid: isValid,
        invalidMessage: invalidMessage,
        onChange: function onChange(v) {
          setValue(v);
          _onChange(v);
        },
        onFocus: function onFocus() {
          if (hideOnBlur) {
            setShow(true);
          }
          _onFocus();
        },
        onBlur: function onBlur() {
          if (hideOnBlur) {
            setShow(false);
          }
          _onBlur();
        },
        tooltipAlignment: tooltipAlignment
      };
    },
    getCharLimitProps: function getCharLimitProps(maxLength) {
      return {
        value: value.length,
        maxValue: maxLength,
        onValidation: onValidation
      };
    }
  };
};
export default useCharLimit;